import { useCallback } from "react";

import { ApiResponseError } from "@/apis/errors";
import { useUnauthenticatedHandler } from "@/hooks/useUnauthenticatedHandler";
import { useDisplayError } from "@/states/error/operations";

export default function useApiResponseErrorHandler() {
  const displayError = useDisplayError();
  const handleUnauthenticated = useUnauthenticatedHandler();

  const handlePageError = useCallback(
    async (err: ApiResponseError) => {
      if (err.status === 401) {
        await handleUnauthenticated();
        return;
      }
      displayError(err);
      return;
    },
    [handleUnauthenticated, displayError],
  );

  return { handlePageError };
}
